import { Breakpoints, DeviceType } from '../types/device-types';
import { DeviceInfo } from '../data-access/store/device-detector.state';

export function isMobile(width: number): boolean {
  return width <= Breakpoints.PHONE;
}

export function isTablet(width: number): boolean {
  return width > Breakpoints.PHONE && width <= Breakpoints.TABLET;
}

export function detectDeviceType(document?: Document): DeviceInfo {
  document ??= window?.document;
  const width = document?.documentElement?.clientWidth ?? 0;

  const deviceType = isMobile(width) ? DeviceType.MOBILE : DeviceType.DESKTOP;
  const tablet = isTablet(width);

  return { deviceType, isTabletBreakpoint: tablet, nativeAppType: null };
}

export function detectIsMacOs(browserNavigator?: Navigator): boolean {
  const userAgentData = (browserNavigator as (Navigator & { userAgentData?: { platform: string } }) | undefined)?.userAgentData;

  return /mac/i.test(userAgentData?.platform ?? browserNavigator?.platform ?? '');
}
